export const OPERATIONS = [
  {
    name: 'Convoy at the approaches',
    type: 'MARITIME WATCH',
    domain: 'maritime',
    pillar: 'military',
    strength: 100,
    sector: 1,
    visual: 'convoy',
    detail: 'A convoy has gone quiet on the western route. The harbour keeps moving while the watch establishes contact.',
    command: 'Reinforce the approaches',
    radio: 'WESTERN APPROACHES / HOLDING PATTERN ESTABLISHED',
  },
  {
    name: 'Aircraft scramble',
    type: 'AIRSPACE WATCH',
    domain: 'air',
    pillar: 'military',
    strength: 110,
    sector: 4,
    visual: 'aircraft',
    detail: 'A transponder-less track is crossing the eastern corridor. Readiness buys time; patience buys certainty.',
    command: 'Raise air readiness',
    radio: 'CHANGI CORRIDOR / SCRAMBLE CLEARED, TRACK UNATTRIBUTED',
  },
  {
    name: 'Cable landing distortion',
    type: 'DIGITAL WATCH',
    domain: 'digital',
    pillar: 'digital',
    strength: 90,
    sector: 9,
    visual: 'cable',
    detail: 'Landing telemetry is reporting impossible readings. The lights stay on while DIS isolates the noise.',
    command: 'Run an intelligence sweep',
    radio: 'CABLE LANDINGS / SIGNAL INTEGRITY UNDER REVIEW',
  },
  {
    name: 'Logistics reroute',
    type: 'ECONOMIC WATCH',
    domain: 'economic',
    pillar: 'economic',
    strength: 105,
    sector: 8,
    visual: 'logistics',
    detail: 'A critical industrial route is backing up. Regular forces can absorb the pressure; a little help keeps the trucks moving.',
    command: 'Reroute the convoy',
    radio: 'JURONG / LOGISTICS FLOW RESTORED VIA SECONDARY ROUTE',
  },
  {
    name: 'Northern movement',
    type: 'GROUND WATCH',
    domain: 'ground',
    pillar: 'military',
    strength: 120,
    sector: 6,
    visual: 'containment',
    detail: 'Sensors report movement beyond the northern boundary. Hold the line and let the picture develop.',
    command: 'Reinforce the sector',
    radio: 'NORTHERN LINE / REGULARS ON STATION',
  },
  {
    name: 'Quiet stand-down',
    type: 'CIVIL DEFENCE WATCH',
    domain: 'civil',
    pillar: 'civil',
    strength: 80,
    sector: 7,
    visual: 'standdown',
    detail: 'A city system flickers across several districts, then settles. The response is already moving before anyone needs to ask.',
    command: 'Keep a response force close',
    radio: 'CENTRAL / CONTAINMENT COMPLETE, CITY RETURNING TO ROUTINE',
  },
  {
    name: 'Supply price spike', type: 'ECONOMIC WATCH', domain: 'economic', pillar: 'economic', strength: 100, sector: 8, visual: 'logistics',
    detail: 'A price signal is moving faster than the cargo. Stockpiles and a little patience keep the shelves unremarkable.', command: 'Release a stockpile buffer', radio: 'ECONOMIC DEFENCE / BUFFER RELEASED, ROUTES STABLE',
  },
  {
    name: 'Communal friction', type: 'SOCIAL WATCH', domain: 'social', pillar: 'social', strength: 85, sector: 7, visual: 'standdown',
    detail: 'A rumour is doing the rounds without a source. The best response is a calm one, delivered early.', command: 'Keep the public briefed', radio: 'SOCIAL DEFENCE / COHESION HOLDING',
  },
  {
    name: 'Infrastructure compromise', type: 'DIGITAL WATCH', domain: 'digital', pillar: 'digital', strength: 115, sector: 10, visual: 'cable',
    detail: 'An ordinary service is behaving oddly. Hardening and a good incident log make the boring answer the right one.', command: 'Harden the network edge', radio: 'NATIONAL NETWORKS / HARDENING COMPLETE',
  },
  {
    name: 'Disinformation weather', type: 'PSYCHOLOGICAL WATCH', domain: 'psychological', pillar: 'psychological', strength: 95, sector: 10, visual: 'containment',
    detail: 'A story with no author is gathering a little too much momentum. Resolve is a quiet, durable defence.', command: 'Run a verified brief', radio: 'PSYCHOLOGICAL DEFENCE / SIGNAL DE-AMPLIFIED',
  },
];

export const ICT_OPERATION = {
  name: 'Reservist call-up signal',
  type: 'ICT CONTINGENCY',
  domain: 'ground',
  pillar: 'military',
  strength: 140,
  sector: 6,
  visual: 'logistics',
  detail: 'The country is still here, your unit is still here, and somehow the stores are still missing one form. This dedicated ICT watch is yours to answer.',
  command: 'Stand by the reservist line',
  radio: 'ICT CONTINGENCY / NSMEN ON STATION',
};

export const EVENT_WINDOW_MS = 2 * 60 * 1000;
export const EVENT_REWARD_SECONDS = 45;
export const MIN_EVENT_INTERVAL_MS = 30 * 60 * 1000;
export const MAX_EVENT_INTERVAL_MS = 60 * 60 * 1000;
export const ICT_INTERVAL_MS = 14 * 24 * 60 * 60 * 1000;
export const ICT_DURATION_MS = 48 * 60 * 60 * 1000;
export const IPPT_INTERVAL_MS = 7 * 24 * 60 * 60 * 1000;
export const IPPT_DURATION_MS = 15 * 60 * 1000;
